export default function countdown() {
  const widgetName = 'countdown';
  const widgetOpts = countdownOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCountdown(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomCountdown(widgetData) {
    const { Title } = widgetData.items[0];

    $widget.find('.card-widget-item').replaceWith(
      `<div class="${widgetName}-dates">${Title}</div>`
    );
  }
}
